import { render, staticRenderFns } from "./CadastroEstoqueTipoMovimentacao.vue?vue&type=template&id=6a3dae58&"
import script from "./CadastroEstoqueTipoMovimentacao.vue?vue&type=script&lang=js&"
export * from "./CadastroEstoqueTipoMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports